import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

// Create a client for TanStack Query (P05-1: Community Feed MVP)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      gcTime: 1000 * 60 * 5, // 5 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Suppress harmless errors from console
// - Badge image 404s: Expected when badge images aren't uploaded yet (fallback icons are used)
// - Lovable.js postMessage: Harmless editor communication errors from Lovable platform
if (typeof window !== 'undefined') {
  // Override console.error to filter out harmless errors
  const originalError = console.error;
  console.error = (...args: any[]) => {
    const message = args.join(' ');
    
    // Suppress badge image 404 errors (we have fallback icons)
    if ((message.includes('lovable-uploads') && (message.includes('.jpg') || message.includes('Badges')) && message.includes('404')) ||
        (message.includes('GET') && message.includes('lovable-uploads') && message.includes('.jpg') && message.includes('404'))) {
      return; // Silently ignore badge image 404s
    }
    
    // Suppress Lovable editor postMessage errors (harmless editor communication)
    if (message.includes('postMessage') && message.includes('DOMWindow') && message.includes('target origin')) {
      return; // Silently ignore Lovable editor postMessage errors
    }
    
    // Call original error handler for other errors
    originalError.apply(console, args);
  };
  
  // Override console.warn for network 404s
  const originalWarn = console.warn;
  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    
    // Suppress badge image 404 warnings
    if ((message.includes('lovable-uploads') && (message.includes('.jpg') || message.includes('Badges')) && message.includes('404')) ||
        (message.includes('GET') && message.includes('lovable-uploads') && message.includes('.jpg'))) {
      return; // Silently ignore badge image 404s
    }
    
    // Call original warn handler for other warnings
    originalWarn.apply(console, args);
  };
  
  // Catch unhandled errors and network failures
  window.addEventListener('error', (event) => {
    const message = event.message || '';
    const source = event.filename || event.target?.src || '';
    
    // Suppress badge image 404 errors
    if ((source.includes('lovable-uploads') && (source.includes('.jpg') || source.includes('Badges'))) ||
        (message.includes('lovable-uploads') && message.includes('.jpg'))) {
      event.preventDefault();
      return false;
    }
    
    // Suppress Lovable postMessage errors
    if (message.includes('postMessage') && message.includes('target origin')) {
      event.preventDefault();
      return false;
    }
  }, true); // Use capture phase
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
